module.exports = __webpack_public_path__ + "assets/img/1587370887980.0092701f.jpg";